import type { Translations } from './types';

export const nl: Translations = {
  common: {
    back: 'Terug',
    cancel: 'Annuleren',
    save: 'Opslaan',
    delete: 'Verwijderen',
    retry: 'Opnieuw proberen',
    loading: 'Laden...',
    close: 'Sluiten',
    yes: 'Ja',
    no: 'Nee',
    ok: 'OK',
    or: 'of',
    play: 'Afspelen',
    stop: 'Stoppen',
    goBack: 'Ga terug',
    returnHome: 'Naar startscherm',
    dismiss: 'Sluiten',
  },
  login: {
    appName: 'CARO Care',
    subtitle: 'Log in om door te gaan',
    emailLabel: 'E-mail',
    passwordLabel: 'Wachtwoord',
    signingIn: 'Bezig met inloggen...',
    signIn: 'Inloggen',
    qrButton: 'Activeren met QR-code',
    helpText: 'Hulp nodig? Neem contact op met',
    adminSetup: 'Beheerder apparaat instellen',
    activeSessionTitle: 'Een ander apparaat is ingelogd',
    activeSessionMessage: 'Dit account is actief op een ander apparaat. Doorgaan zal alle andere apparaten uitloggen.',
    logoutOthers: 'Doorgaan & Anderen Uitloggen',
    cancelLogin: 'Annuleren',
  },
  home: {
    greetingMorning: 'Goedemorgen',
    greetingAfternoon: 'Goedemiddag',
    greetingEvening: 'Goedenavond',
    greetingNight: 'Goedenacht',
    phoneReady: 'Gereed',
    phoneConnecting: '...',
    phoneError: 'Fout',
    geofenceOutside: 'Buiten de zone!',
    geofenceInside: 'Binnen de zone',
    geofenceIndicatorOutside: 'Buiten',
    geofenceIndicatorSafe: 'Veilig',
    editLayoutEdit: 'Startscherm aanpassen',
    editLayoutDone: 'Aanpassen voltooien',
    openDoor: 'Deur openen',
    openDoorSuccess: 'Deur wordt geopend',
    openDoorError: 'Kon de deur niet openen',
    apps: 'Apps',
    widgetButtons: 'Knoppen',
  },
  emergency: {
    confirmationTitle: 'Weet u zeker dat u noodhulp nodig heeft?',
    buttonYes: 'JA',
    buttonNo: 'NEE',
    buttonNoCancel: 'Nee, annuleren',
    buttonCancel: 'ANNULEREN',
    countdownMessage: 'Noodoproep over {seconds} seconden...',
    calling: 'Hulpdiensten worden gebeld...',
    connected: 'Verbonden',
    resetAlarm: 'Alarm resetten',
    cancelled: 'Noodoproep geannuleerd',
    errorApiFailed: 'Hulpdiensten konden niet via de app worden bereikt.',
    errorSipUnavailable: 'Telefoondienst is niet beschikbaar. Bel bij noodgevallen rechtstreeks 112.',
    call112: 'Bel 112',
    tryAgain: 'Opnieuw proberen',
    callHelp: 'Noodoproep',
    fiveSecondsRemaining: 'Nog 5 seconden',
    dispatchConnecting: 'Hulpdienst waarschuwen…',
    dispatchRetry: 'Opnieuw proberen… (poging {n})',
    dispatchFailed: 'Verbinden lukt niet. We blijven proberen…',
    dispatchFailedVoice: 'De verbinding met de hulpdienst lukt niet. We blijven proberen. Blijf rustig.',
    tryingToCall: 'Hulpdienst oproepen…',
    callingWith: 'In gesprek met de hulpdienst',
    onRoute: 'De hulpdienst is onderweg',
    alarmSent: 'Alarm verzonden, hulp wordt gewaarschuwd…',
    alarmActive: 'Hulp wordt geregeld. Blijf rustig.',
  },
  settings: {
    title: 'Instellingen',
    homeScreen: 'Startscherm',
    customizeButtons: 'Knoppen aanpassen',
    connectionStatus: 'Verbindingsstatus',
    allConnected: 'Alles verbonden',
    display: 'Scherm & Thema',
    language: 'Taal',
    about: 'Over CARO Care',
    testMode: 'Testmodus',
    logout: 'Uitloggen',
    replayOnboarding: 'Welkomstgids opnieuw bekijken',
    permissions: 'App-rechten',
    permissionsValue: 'Microfoon, camera, locatie',
    permissionsTitle: 'App-rechten',
    permissionsIntro: 'Deze rechten zijn nodig zodat het toestel oproepen, video en meldingen goed kan gebruiken.',
    permissionsAllowAll: 'Alle rechten toestaan',
    permissionsRecheck: 'Opnieuw controleren',
    permissionsAllGranted: 'Alle rechten zijn toegestaan',
    permGranted: 'Toegestaan',
    permDenied: 'Geweigerd',
    permPrompt: 'Nog niet toegestaan',
    permDeniedHelp: 'Geweigerd. Schakel dit in via de systeeminstellingen van het toestel.',
    permMic: 'Microfoon',
    permMicDesc: 'Nodig om te bellen',
    permCamera: 'Camera',
    permCameraDesc: 'Nodig voor videogesprekken en deurcamera',
    permLocation: 'Locatie',
    permLocationDesc: 'Nodig voor veiligheid en zonebewaking',
    permNotifications: 'Meldingen',
    permNotificationsDesc: 'Nodig om binnenkomende oproepen te tonen',
  },
  buttonLabels: {
    dialer: 'Bellen',
    contacts: 'Contacten',
    photos: "Foto's",
    info: 'Info',
    games: 'Spelletjes',
    voicemail: 'Voicemail',
    callHistory: 'Oproepen',
    settings: 'Instellingen',
    openDoor: 'Deur openen',
    agenda: 'Agenda',
    weather: 'Weer',
    news: 'Nieuws',
  },
  onboarding: {
    splashTagline: 'Zorg binnen handbereik',
    welcomeTitle: 'Welkom bij CARO Care',
    welcomeSubtitle: 'Uw persoonlijke zorgassistent, ontworpen om u verbonden en veilig te houden.',
    connectedTitle: 'Blijf verbonden',
    connectedSubtitle: 'Bel, zie wie er aan de deur is en blijf in contact met familie en verzorgers.',
    homeScreenTitle: 'Uw startscherm',
    homeScreenSubtitle: 'Weer, nieuws, uw agenda en meer — alles aanpasbaar naar uw wensen.',
    getStartedTitle: 'Klaar om te beginnen',
    getStartedSubtitle: 'Laten we uw apparaat instellen. Het duurt maar even.',
    next: 'Volgende',
    skip: 'Overslaan',
    getStartedButton: 'Aan de slag',
  },
  contacts: {
    title: 'Contacten',
    emptyTitle: 'Nog geen contacten.',
    emptyDescription: 'Uw familie en verzorgers kunnen contacten voor u toevoegen via het portaal.',
    callContact: 'Bellen',
    loadError: 'Contacten konden niet worden geladen. Probeer het opnieuw.',
  },
  callHistory: {
    title: 'Belgeschiedenis',
    filterAll: 'Alle',
    filterMissed: 'Gemist',
    filterAnswered: 'Beantwoord',
    filterVoicemail: 'Voicemail',
    loadError: 'Belgeschiedenis kon niet worden geladen',
    networkError: 'Netwerkfout',
    noCalls: 'Nog geen oproepen',
    today: 'Vandaag',
    yesterday: 'Gisteren',
    statusAnswered: 'Beantwoord',
    statusMissed: 'Gemist',
    statusVoicemail: 'Voicemail',
    statusRinging: 'Gaat over',
    statusRejected: 'Geweigerd',
    statusFailed: 'Mislukt',
  },
  voicemail: {
    title: 'Voicemail',
    loadingVoicemails: 'Voicemails laden...',
    loadError: 'Voicemails konden niet worden geladen',
    emptyTitle: 'Geen voicemails',
    emptyDescription: 'Wanneer iemand een voicemail achterlaat, verschijnt deze hier.',
    statusKept: 'BEWAARD',
    statusAutoDelete: '14d automatisch verwijderen',
    keep: 'Bewaren',
    deleteVoicemail: 'Verwijderen',
    confirmDelete: 'Deze voicemail verwijderen?',
    playError: 'Voicemail kon niet worden afgespeeld',
    deleteError: 'Voicemail kon niet worden verwijderd',
    updateError: 'Voicemail kon niet worden bijgewerkt',
    daysAgo: '{n} dagen geleden',
    today: 'Vandaag',
    yesterday: 'Gisteren',
  },
  inCall: {
    connecting: 'Verbinden...',
    dialing: 'Bellen...',
    onHold: 'In de wacht',
    ended: 'Gesprek be\u00ebindigd',
    mute: 'Dempen',
    unmute: 'Dempen uit',
    keypad: 'Toetsen',
    speaker: 'Luidspreker',
    earpiece: 'Oorstuk',
    hold: 'In de wacht',
    resume: 'Hervatten',
  },
  incomingCall: {
    emergencyCallback: 'Nood terugbeloproep',
    incoming: 'Inkomend gesprek',
    autoAnswering: 'Automatisch beantwoorden...',
    decline: 'Weigeren',
    answer: 'Opnemen',
  },
  doorbell: {
    viewing: 'Er is iemand aan de deur',
    calling: 'Verbinden...',
    active: 'Verbonden',
    doorOpened: 'Deur geopend',
    opening: 'Deur openen...',
    done: 'Gesprek be\u00ebindigd',
    noCamera: 'Geen camera beschikbaar',
    entrance: 'Ingang',
    openDoor: 'Deur openen',
    answer: 'Opnemen',
    decline: 'Weigeren',
    hangup: 'Gesprek be\u00ebindigen',
    afwijzen: 'Afwijzen',
    opnemen: 'Opnemen',
    ophangen: 'Ophangen',
    deurOpenen: 'Deur openen',
    // Door release (idea #8) — four states, and the wording is load-bearing.
    // LD-15: green means the Commander ACCEPTED the unlock, never that the door
    // physically opened. Hence "wordt geopend", not `doorOpened`'s "geopend".
    doorReleasing: 'Deur wordt geopend',
    // Amber: the server path failed and DTMF was fired as a SECOND attempt.
    doorRetried: 'Opnieuw geprobeerd',
    // Amber: there was no server path at all; DTMF was the FIRST attempt.
    doorSent: 'Deur openen verzonden',
    // Red — the one case where we know for certain nothing was sent.
    doorFailed: 'Openen mislukt',
  },
  photos: {
    title: "Foto's",
    tabAll: 'Alle',
    tabFavorites: 'Favorieten',
    tabHidden: 'Verborgen',
    emptyFavorites: "Nog geen favoriete foto's. Tik op het hartje bij een foto om deze toe te voegen!",
    emptyHidden: "Geen verborgen foto's.",
    emptyAll: "Nog geen foto's. Uw familie kan foto's sturen via hun link.",
    unavailable: 'Foto niet beschikbaar',
  },
  agenda: {
    title: 'Agenda',
    today: 'Vandaag',
    allDay: 'Hele dag',
    spots: 'plaatsen',
    open: 'Open',
    addedBy: 'Toegevoegd door',
    emptyMessage: 'Geen activiteiten gepland voor deze week',
    cancelSignup: 'Afmelden',
    join: 'Deelnemen',
    previousWeek: 'Vorige week',
    nextWeek: 'Volgende week',
    tomorrow: 'Morgen',
    addEntry: '+ Voeg toe',
    privateMarker: 'Privé',
    privateExplain: 'Alleen u ziet dit',
    newEntryTitle: 'Iets in uw agenda zetten',
    entryTitleLabel: 'Wat is het?',
    entryWhenLabel: 'Wanneer?',
    entryDurationLabel: 'Hoe lang?',
    save: 'Bewaren',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    signupOpen: 'Inschrijven',
    signupClosed: 'Inschrijven is gesloten',
    signupFull: 'Volzet',
    signupAlready: 'U bent ingeschreven',
    moreInfo: 'Meer info',
    withdrawClosed: 'Deze activiteit is bezig of voorbij. Uitschrijven kan niet meer — vraag het aan de begeleiding.',
    withdrawFailed: 'Uitschrijven is niet gelukt',
    noBillingAccount: 'Inschrijven via de begeleiding',
    waitlisted: 'U staat op de wachtlijst',
    whoIsComing: 'Wie gaat er mee?',
    attendeeYou: 'Uzelf',
    confirmTitle: 'Even bevestigen',
    confirmTotal: 'Totaal',
    confirmOnApartmentBill: 'Dit komt op de rekening van uw appartement.',
    confirmYes: 'Ja, schrijf mij in',
    confirmNo: 'Nee, toch niet',
    signupFailed: 'Inschrijven is niet gelukt. Probeer opnieuw of vraag het aan de begeleiding.',
    priceChanged: 'De prijs is ondertussen veranderd. Bekijk het opnieuw.',
  },
  dialer: {
    title: 'Telefoon',
    connectingMessage: 'Verbinden met telefoondienst...',
    notConnectedMessage: 'Telefoondienst niet verbonden',
  },
  info: {
    title: 'Info',
    myProfile: 'Mijn profiel',
    name: 'Naam',
    email: 'E-mail',
    location: 'Locatie',
    myBuilding: 'Mijn gebouw',
    building: 'Gebouw',
    needHelp: 'Hulp nodig?',
    helpText: 'Druk op de rode noodknop op het startscherm of vraag een verzorger om hulp.',
    about: 'Over deze app',
    appVersion: 'Versie',
  },
  connectivity: {
    title: 'Verbindingsstatus',
    allConnected: 'Alle systemen verbonden',
    limited: 'Beperkte verbinding',
    offline: 'Offline',
    checking: 'Controleren...',
    emergencyAvailable: 'Noodoproepen beschikbaar',
    degradedMessage: 'Sommige diensten zijn mogelijk niet beschikbaar',
    offlineMessage: 'Geen verbinding gedetecteerd',
    networkLabel: 'Wi-Fi / Netwerk',
    networkDescription: 'Lokale netwerkverbinding',
    internetLabel: 'Internet',
    internetDescription: 'Internettoegang',
    apiLabel: 'CARO Server',
    apiDescription: 'CARO clouddiensten',
    sipLabel: 'Telefoondienst',
    sipDescription: 'Belmogelijkheid',
    mqttLabel: 'Monitoring',
    mqttDescription: 'Apparaatbewaking & externe opdrachten',
    statusOk: 'OK',
    statusDown: 'Niet beschikbaar',
    checkAgain: 'Opnieuw controleren',
    noNetwork: 'Geen netwerkverbinding',
    offlineEmergencyText: 'Bel bij noodgevallen rechtstreeks 112 met uw telefoon.',
  },
  homeScreenSettings: {
    title: 'Startscherm',
    subtitle: 'Kies welke knoppen op uw startpagina verschijnen',
    buttonCount: '{count} van {total} knoppen zichtbaar',
    resetToDefault: 'Standaard herstellen',
  },
  games: {
    title: 'Spelletjes',
    subtitle: 'Houd uw geest scherp en veel plezier',
    memory: { name: 'Memory', desc: 'Vind de paren' },
    sudoku: { name: 'Sudoku', desc: 'Getallenspel' },
    wordSearch: { name: 'Woordzoeker', desc: 'Vind verborgen woorden' },
    trivia: { name: 'Quiz', desc: 'Test uw kennis' },
    game2048: { name: '2048', desc: 'Schuif en voeg tegels samen' },
    solitaire: { name: 'Patience', desc: 'Klassiek kaartspel' },
    ticTacToe: { name: 'Boter-kaas-en-eieren', desc: 'X en O strategie' },
    hangman: { name: 'Galgje', desc: 'Raad het woord' },
    colorMatch: { name: 'Kleuren onthouden', desc: 'Onthoud het patroon' },
    chess: { name: 'Schaken', desc: 'Klassiek strategiespel' },
    checkers: { name: 'Dammen', desc: 'Spring en sla' },
    findDifferences: { name: 'Zoek de verschillen', desc: 'Vind de veranderingen' },
    slidingPuzzle: { name: 'Schuifpuzzel', desc: 'Schuif tegels op volgorde' },
  },
  gameCommon: {
    playAgain: 'Opnieuw spelen',
    changeDifficulty: 'Moeilijkheid wijzigen',
    backToGames: 'Terug naar spelletjes',
    newGame: 'Nieuw spel',
    tryAgain: 'Opnieuw proberen',
    keepPlaying: 'Doorspelen',
    congratulations: 'Gefeliciteerd!',
    score: 'Score',
    best: 'Beste',
    time: 'Tijd',
    moves: 'Zetten',
    easy: 'Makkelijk',
    medium: 'Gemiddeld',
    hard: 'Moeilijk',
    gameOver: 'Spel voorbij!',
  },
  memoryGame: {
    chooseDifficulty: 'Kies moeilijkheid',
    matchPairsSubtitle: 'Vind alle paren om te winnen!',
    encourageAmazing: 'Geweldig geheugen! U bent een natuurtalent!',
    encourageGreat: 'Goed gedaan! Heel knap!',
    encourageNice: 'Mooi werk! Blijf oefenen!',
    encourageWellDone: 'Prima gedaan! Elk spel maakt u scherper!',
  },
  sudokuGame: {
    chooseDifficulty: 'Kies uw moeilijkheid:',
    blanks: 'lege vakjes',
    hintsUsed: 'Hints gebruikt',
    hintsDisplay: 'Hints',
    solvedPuzzle: 'U heeft de puzzel opgelost!',
  },
  game2048: {
    youReached: 'U heeft 2048 bereikt!',
  },
  triviaGame: {
    chooseCategory: 'Kies een categorie om de quiz te starten!',
    questions: 'vragen',
    questionProgress: 'Vraag {current} van {total}',
    correct: 'Goed zo! Uitstekend!',
    incorrect: 'Helaas. Het juiste antwoord is hierboven gemarkeerd.',
    nextQuestion: 'Volgende vraag',
    seeResults: 'Resultaten bekijken',
    chooseCategoryBtn: 'Kies categorie',
    resultPerfect: 'Perfecte score! U bent een echte quizmaster!',
    resultExcellent: 'Uitstekend! U weet er echt veel van!',
    resultGreat: 'Goed gedaan! U heeft een prachtig geheugen!',
    resultGood: 'Goed geprobeerd! Blijf spelen om meer te leren!',
    resultNiceTry: 'Mooi geprobeerd! Elk spel maakt u slimmer!',
    history: 'Geschiedenis',
    nature: 'Natuur',
    music: 'Muziek',
    geography: 'Aardrijkskunde',
    science: 'Wetenschap',
  },
  wordSearchGame: {
    chooseTheme: 'Kies een thema om te beginnen',
    words: 'woorden',
    theme: 'Thema',
    wordsFound: 'gevonden',
    hintSelectStart: 'Tik op de eerste letter van een woord',
    hintSelectEnd: 'Tik op het einde van het woord',
    allWordsFound: 'Alle woorden gevonden!',
    completionMessage: 'U heeft de puzzel voltooid!',
    newPuzzle: 'Nieuwe puzzel',
    changeTheme: 'Thema wijzigen',
    animals: 'Dieren',
    food: 'Eten',
    natureTheme: 'Natuur',
    home: 'Huis',
    colors: 'Kleuren',
  },
  hangmanGame: {
    guessTheWord: 'Raad het woord!',
    category: 'Categorie',
    youWon: 'U heeft het geraden!',
    youLost: 'Te veel foute letters!',
    theWordWas: 'Het woord was',
    wrongGuesses: 'Foute letters',
    animals: 'Dieren',
    food: 'Eten',
    countries: 'Landen',
    household: 'Huishouden',
  },
  colorMatchGame: {
    watchPattern: 'Bekijk het patroon...',
    yourTurn: 'Uw beurt!',
    round: 'Ronde',
    bestStreak: 'Beste reeks',
    wrongPattern: 'Fout! Spel voorbij.',
    newRecord: 'Nieuw record!',
  },
  solitaireGame: {
    undo: 'Ongedaan maken',
    draw: 'Trekken',
    autoComplete: 'Automatisch voltooien',
    youWon: 'U heeft gewonnen!',
    movesUsed: 'Zetten gebruikt',
  },
  ticTacToeGame: {
    yourTurn: 'Uw beurt (X)',
    aiTurn: 'Computer denkt na...',
    youWin: 'U wint!',
    aiWins: 'Computer wint!',
    draw: 'Gelijkspel!',
    chooseDifficulty: 'Kies moeilijkheid:',
    wins: 'Gewonnen',
    losses: 'Verloren',
    draws: 'Gelijk',
  },
  browser: {
    title: 'Browser',
    noUrl: 'Geen URL opgegeven',
    emergency: 'Noodgeval',
  },
  display: {
    title: 'Scherm & Thema',
    brightness: 'Helderheid',
    screen: 'Scherm',
    sleepMode: 'Slaapstand',
    sleepModeDesc: 'Schakel het scherm uit. Tik ergens om wakker te worden.',
    tapToWake: 'Tik om te ontwaken',
    fontSize: 'Lettergrootte',
    fontNormal: 'Normaal',
    fontLarge: 'Groot',
    fontXLarge: 'Extra groot',
    fontHuge: 'Heel groot',
    fontGiant: 'Reusachtig',
    colorTheme: 'Kleurthema',
    light: 'Licht',
    dark: 'Donker',
    highContrast: 'Hoog contrast',
    screensaverMode: 'Schermbeveiliging',
    screensaverPhotos: "Foto's",
    screensaverClockOnly: 'Alleen klok',
    standbyBackground: 'Achtergrond schermbeveiliging',
    clockStyle: 'Klokstijl',
    clockDigital: 'Digitaal',
    clockAnalog: 'Analoog',
    clockSize: 'Klokgrootte',
    clockSmall: 'Klein',
    clockMedium: 'Normaal',
    clockLarge: 'Groot',
    clockXLarge: 'Extra groot',
    clockHuge: 'Reuze',
    clockBold: 'Klokcijfers',
    clockBoldOff: 'Fijn',
    clockBoldOn: 'Vet',
    weatherLocation: 'Weerlocatie',
    weatherLocationPlaceholder: 'bijv. Deinze, België',
    weatherLocationHint: 'Laat leeg voor gebouwlocatie',
    detectLocation: 'Detecteer',
    reduceMotion: 'Beweging beperken',
    reduceMotionHint: 'Beperk animaties en overgangen in de app.',
    reduceMotionAuto: 'Automatisch (apparaat volgen)',
    reduceMotionOn: 'Aan',
    reduceMotionOff: 'Uit',
  },
  today: {
    title: 'Vandaag',
    noEvents: 'Geen activiteiten vandaag',
    now: 'NU',
    allDay: 'Hele dag',
    inTime: 'over {time}',
    nextEvent: 'Straks: {title} om {time}',
  },
  weather: {
    title: 'Weer',
    feelsLike: 'Voelt als',
    humidity: 'Vochtigheid',
    wind: 'Wind',
    sunrise: 'Zonsopgang',
    sunset: 'Zonsondergang',
    forecast: 'Vooruitzicht',
    loading: 'Weer laden...',
    unavailable: 'Weer niet beschikbaar',
    high: 'H',
    low: 'L',
  },
  news: {
    title: 'Nieuws',
    loading: 'Nieuws laden...',
    noArticles: 'Geen artikelen beschikbaar',
    readMore: 'Lees meer',
    sources: 'Bronnen',
    minutesAgo: '{n}m geleden',
    hoursAgo: '{n}u geleden',
  },
  permissions: {
    title: 'Toestemmingen vereist',
    description: 'CARO Care heeft de volgende toestemmingen nodig om goed te werken. Sta toegang toe om verder te gaan.',
    microphone: 'Microfoon',
    microphoneDesc: 'Vereist voor telefoongesprekken en noodalarm',
    camera: 'Camera',
    cameraDesc: 'Vereist voor deurbel camera en QR code scannen',
    location: 'Locatie',
    locationDesc: 'Vereist voor veiligheidsmonitoring in uw gebouw',
    allowAll: 'Alle toestemmingen toestaan',
    deniedHelp: 'Sommige toestemmingen zijn geweigerd. Open Instellingen > Apps > CARO Care > Machtigingen om ze in te schakelen.',
    notifications: 'Meldingen',
    notificationsDesc: 'Vereist voor inkomende oproepwaarschuwingen en noodmeldingen',
    openSettings: 'Open Instellingen',
  },
  battery: {
    lowTitle: 'Batterij bijna leeg',
    lowMessage: 'Batterij is bijna leeg. Sluit de oplader aan.',
    highTitle: 'Batterij opgeladen',
    highMessage: 'Batterij is voldoende opgeladen. U kunt de oplader loskoppelen om de batterij te sparen.',
    lowSpoken: 'Let op. Uw batterij is bijna leeg. Sluit alstublieft de oplader aan.',
  },
};
